if (!window.Eurus.loadedScript.includes('customize-picker.js')) {
  window.Eurus.loadedScript.push('customize-picker.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCustomizePicker', () => ({
        dataCheckbox: [],
        disableInput: true,
        radioChecked: '',
        validation(el) {
          if (el.value == "") {
            el.classList.add("required-picker");
          }
          else {
            el.classList.remove("required-picker");
          }
          this.validateErrorBtn(el);
        },
        validateErrorBtn(el) {
          var productInfo = el.closest('.product-info');
          var paymentBtn = productInfo.querySelector(".payment-button--clone");
          var propertiesInput = productInfo.querySelectorAll(".customization-picker.required-picker");
          if (propertiesInput.length) {
            paymentBtn?.classList.remove('hidden');
          }
          else {
            paymentBtn?.classList.add('hidden');
          }
        },
        setValueBlank(el) {
          if (el.value == '') {
            this.disableInput = true;
          } else {
            this.disableInput = false;
          }
        },
        validateErrorAddAsBundle(el) {
          var productInfo = el.closest('.product-info');
          var propertiesInput = productInfo.querySelectorAll(".customization-picker");
          var optionValid = true;
          propertiesInput.length && propertiesInput.forEach((input) => {
            if (input.required && input.value == '' || input.classList.contains("validate-checkbox")) {
              input.classList.add("required-picker");
              if (optionValid) optionValid = false;
            }
          });
          return optionValid;
        },
        validateError(el) {
          var productInfo = el.closest('.product-info');
          var propertiesInput = productInfo.querySelectorAll(".customization-picker");
          let scrollStatus = false;
          var optionValid = true;
          propertiesInput.length && propertiesInput.forEach((input) => {
            if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
              input.classList.add("required-picker");
              if (!scrollStatus) {
                input.parentElement.querySelector('.text-required').scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                });
                scrollStatus = true;
              }
            }
          });

          return optionValid;
        },
        validateCheckBox(el, minLimit, maxLimit) {
          var groupCheckbox = el.closest(".customize-checkbox");
          const checkedInputs = groupCheckbox.querySelectorAll('input[type=checkbox]:checked');
          if (checkedInputs.length >= minLimit) {
            el.classList.remove('required-picker', 'validate-checkbox');
          } else {
            el.classList.add('required-picker', 'validate-checkbox');
          }

          if (maxLimit > 0 && maxLimit >= minLimit) {
            const disableInput = checkedInputs.length >= maxLimit;
            const uncheckedInputs = groupCheckbox.querySelectorAll('input[type=checkbox]:not(:checked)');
            uncheckedInputs.forEach((uncheckedInput) => {
              uncheckedInput.disabled = disableInput;
            });
          }
          if (minLimit > 0) {
            this.validateErrorBtn(el);
          }
        },
        handleFilesChange(inputEl, fileList) {
          const dropZoneWrapElm = inputEl.closest('.drop-zone-wrap');
          const dropZone = dropZoneWrapElm;
          const maxFiles = 6;

          dropZone.classList.remove('drop-zone-wrap--error');
          inputEl.classList.remove('required-picker');

          if (!fileList || fileList.length === 0) return;

          // 获取当前已有的文件数量
          const currentFiles = Alpine.$data(dropZoneWrapElm).files || [];
          const remainingSlots = maxFiles - currentFiles.length;

          if (remainingSlots <= 0) {
            inputEl.value = '';
            const errorMsg = dropZoneWrapElm.querySelector('.error-max-file');
            if (errorMsg) {
              errorMsg.textContent = `最多只能上传 ${maxFiles} 个文件，请先删除部分文件后再添加`;
              errorMsg.classList.remove('hidden');
            }
            setTimeout(() => {
              if (errorMsg) errorMsg.classList.add('hidden');
            }, 4000);
            return;
          }

          // 如果用户选择的文件数量超过剩余槽位，给出提示
          if (fileList.length > remainingSlots) {
            const errorMsg = dropZoneWrapElm.querySelector('.error-max-file');
            if (errorMsg) {
              errorMsg.textContent = `只能添加 ${remainingSlots} 个文件（已选择 ${fileList.length} 个，但只能添加 ${remainingSlots} 个）`;
              errorMsg.classList.remove('hidden');
            }
            setTimeout(() => {
              if (errorMsg) errorMsg.classList.add('hidden');
            }, 4000);
          }

          // 限制添加的文件数量
          const filesToAdd = Array.from(fileList).slice(0, remainingSlots);

          // 验证文件大小并添加到列表
          let hasLargeFile = false;
          filesToAdd.forEach((file) => {
            const filesize = ((file.size / 1024) / 1024).toFixed(4);
            if (filesize > 5) {
              hasLargeFile = true;
              return; // 跳过这个文件
            }

            this.addFileToPreview(dropZoneWrapElm, file);
          });

          // 如果有文件过大，显示错误提示
          if (hasLargeFile) {
            dropZone.classList.add('drop-zone-wrap--error');
            setTimeout(() => {
              dropZone.classList.remove('drop-zone-wrap--error');
            }, 3000);
          }

          // 清空输入框以便下次选择
          inputEl.value = '';
        },
        addFileToPreview(dropZoneWrapElm, file) {
          const fileData = Alpine.$data(dropZoneWrapElm);
          if (!fileData.files) fileData.files = [];

          const reader = new FileReader();
          reader.addEventListener('load', () => {
            const isImage = /\.(jpe?g|png|gif|webp)$/i.test(file.name);
            const fileName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;

            fileData.files.push({
              file: file,
              name: fileName,
              type: this.formatFileType(file),
              size: this.calculateSize(file),
              preview: isImage ? reader.result : null,
              isImage: isImage
            });

            // 更新隐藏的 input 元素
            this.updateFileInputs(dropZoneWrapElm);
          }, false);

          reader.readAsDataURL(file);
        },
        updateFileInputs(dropZoneWrapElm) {
          const fileData = Alpine.$data(dropZoneWrapElm);
          if (!fileData.files) return;

          // 使用 nextTick 确保 DOM 已更新
          setTimeout(() => {
            fileData.files.forEach((fileObj, index) => {
              // 使用 data-index 属性来查找对应的 input
              const fileInput = dropZoneWrapElm.querySelector(`input.file-input-item[data-index="${index}"]`);
              const fileInputSticky = dropZoneWrapElm.querySelector(`input.file-input-item-sticky[data-index="${index}"]`);

              if (fileInput && fileObj.file) {
                try {
                  const dataTransfer = new DataTransfer();
                  dataTransfer.items.add(fileObj.file);
                  fileInput.files = dataTransfer.files;
                } catch (e) {
                  console.warn('无法设置文件输入:', e);
                }
              }

              if (fileInputSticky && fileObj.file) {
                try {
                  const dataTransfer = new DataTransfer();
                  dataTransfer.items.add(fileObj.file);
                  fileInputSticky.files = dataTransfer.files;
                } catch (e) {
                  console.warn('无法设置粘性文件输入:', e);
                }
              }
            });

          }, 100);
        },
        setDragAndDrop(el) {
          const inputElement = el.querySelector('.drop-zone__input');
          const dropZoneWrapElm = inputElement.closest('.drop-zone-wrap');
          const dropZoneElement = dropZoneWrapElm.querySelector('.drop-zone');

          dropZoneElement.addEventListener('click', (e) => {
            inputElement.click();
          });

          inputElement.addEventListener('change', (e) => {
            if (inputElement.files.length) {
              this.handleFilesChange(inputElement, inputElement.files);
            }
          });

          dropZoneElement.addEventListener('dragover', (e) => {
            e.preventDefault();
            dropZoneElement.classList.add('drop-zone--over');
          });

          ["dragleave", "dragend"].forEach((type) => {
            dropZoneElement.addEventListener(type, (e) => {
              dropZoneElement.classList.remove('drop-zone--over');
            });
          });

          dropZoneElement.addEventListener('drop', (e) => {
            e.preventDefault();

            if (e.dataTransfer.files.length) {
              this.handleFilesChange(inputElement, e.dataTransfer.files);
            }

            dropZoneElement.classList.remove('drop-zone--over');
          });
        },
        removeFile(index, el) {
          const dropZoneWrapElm = el.closest('.drop-zone-wrap');
          const fileData = Alpine.$data(dropZoneWrapElm);

          if (fileData.files && fileData.files[index]) {
            // 删除文件
            fileData.files.splice(index, 1);

            // 重新更新所有文件输入的索引和文件
            setTimeout(() => {
              this.updateFileInputs(dropZoneWrapElm);
            }, 50);

            // 如果文件列表为空，重置禁用状态
            if (fileData.files.length === 0) {
              this.disableInput = true;
            }
          }
        },
        formatFileType(file) {
          const type = file.type;
          const splitType = type.split('/');
          const subtype = splitType[1];
          let formattedType = subtype;
          let handleSubtype = subtype.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
          const applicationType = {
            'pdf': subtype.toUpperCase(),
            'vnd-ms-excel': 'Excel',
            'vnd-openxmlformats-officedocument-spreadsheetml-sheet': 'Excel',
            'vnd-ms-powerpoint': 'PowerPoint',
            'vnd-openxmlformats-officedocument-presentationml-presentation': 'PowerPoint',
            'x-msvideo': 'AVI',
            'html': 'HTML',
            'msword': 'Word',
            'vnd-openxmlformats-officedocument-wordprocessingml-document': 'Word',
            'csv': 'CSV',
            'mpeg': 'MP3 Audio',
            'webm': 'WEBM Audio',
            'mp4-video': 'MP4 Video',
            'mpeg-video': 'MPEG Video',
            'webm-video': 'WEBM Video',
            'vnd-rar': 'RAR archive',
            'rtf': 'RTF',
            'plain': 'Text',
            'wav': 'WAV',
            'vnd-adobe-photoshop': 'Adobe Photoshop',
            'postscript': 'Adobe Illustrator'
          };

          if (type.startsWith('image/')) {
            if (applicationType[handleSubtype]) {
              formattedType = applicationType[handleSubtype];
            } else {
              formattedType = splitType[1].toUpperCase();
              formattedType = `${formattedType} Image`;
            }
          } else if (type.startsWith('video/')) {
            const handleVideoSubtype = `${handleSubtype}-video`
            if (applicationType[handleVideoSubtype]) formattedType = applicationType[handleVideoSubtype];
          } else {
            if (applicationType[handleSubtype]) formattedType = applicationType[handleSubtype];
          }

          return formattedType;
        },
        calculateSize(file) {
          let numberOfBytes = file.size;
          if (numberOfBytes === 0) return 0;

          const units = [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
          ];

          const exponent = Math.min(
            Math.floor(Math.log(numberOfBytes) / Math.log(1024)),
            units.length - 1,
          );
          const approx = numberOfBytes / 1024 ** exponent;
          const output =
            exponent === 0
              ? `${numberOfBytes} bytes`
              : `${approx.toFixed(2)} ${units[exponent]}`;

          return output;
        }
      }));
    });
  });
}
